import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null

    return (
        <div className='flex items-center justify-center gap-2'>
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className='px-3 py-1 rounded disabled:opacity-50'
            >
                <FaChevronLeft />
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
                <button
                    key={i}
                    onClick={() => onPageChange(i + 1)}
                    className={`px-3 py-1 rounded ${
                        currentPage === i + 1 ? 'bg-yellow-500 text-white' : 'bg-gray-100'
                    }`}
                >
                    {i + 1}
                </button>
            ))}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className='px-3 py-1 rounded disabled:opacity-50'
            >
                <FaChevronRight />
            </button>
        </div>
    )
}

export default Pagination
